
export default (t) => [
  {
    text: t('Group Name'),
    value: 'name',
    sortable: false,
    togglable: true
  },
  {
    text: t('Point Multiplier'),
    value: 'point_multiplier',
    sortable: true,
    width: 150,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 120,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 150
  },
];
